import {ReactChild} from 'react';
import styles from './ControllButton.module.scss';
import Button from '../../../common/component/Button';

interface IProps {
  className?: string;
  disabled?: boolean;
  children: ReactChild;
  onClick?: () => void;
}

export default function ControllButton({
  className,
  disabled = false,
  children,
  onClick,
}: IProps) {
  return (
    <Button
      className={cn(
        'h-48 overflow-hidden w-48 rounded-50per',
        'bg-black light:bg-white',
        'border border-solid !border-opacity-10 border-white light:border-black',
        styles.controllerButton,
        styles.shadow,
        className
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
